import { useEffect, useState } from 'react';
import { apiClient } from '../services/api';
import type { TenantSummary } from '../types';

type DashboardStat = { label: string; value: string | number };

export function DashboardPage() {
  const [stats, setStats] = useState<DashboardStat[]>([
    { label: 'Total Tenants', value: '—' },
    { label: 'Active Users', value: '—' },
    { label: 'Open Incidents', value: '—' },
    { label: 'Queue Depth', value: '—' },
  ]);

  useEffect(() => {
    let isMounted = true;
    Promise.allSettled([apiClient.getTenants(), apiClient.getSystemInfo()])
      .then(([tenantsResult, systemInfoResult]) => {
        if (!isMounted) return;

        const tenants = tenantsResult.status === 'fulfilled' ? (tenantsResult.value as TenantSummary[]) : [];
        const info = systemInfoResult.status === 'fulfilled' ? (systemInfoResult.value as Record<string, unknown>) : {};
        const activeUsers = Number(info.activeUsers ?? 0);
        const openIncidents = Number(info.openIncidents ?? 0);
        const queueDepth = Number(info.queueDepth ?? 0);

        setStats([
          { label: 'Total Tenants', value: tenants.length },
          { label: 'Active Users', value: Number.isFinite(activeUsers) ? activeUsers : '—' },
          { label: 'Open Incidents', value: Number.isFinite(openIncidents) ? openIncidents : '—' },
          { label: 'Queue Depth', value: Number.isFinite(queueDepth) ? queueDepth : '—' },
        ]);
      })
      .catch(() => undefined);

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <div>
      <h1 className="text-2xl font-semibold">Dashboard</h1>
      <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">System-wide overview for administrators.</p>
      <div className="mt-4 grid gap-4 md:grid-cols-2 xl:grid-cols-4">
        {stats.map((stat) => (
          <div className="card" key={stat.label}>
            <p className="text-sm text-gray-500 dark:text-gray-400">{stat.label}</p>
            <p className="mt-2 text-3xl font-semibold">{stat.value}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
